// polyfills for app working correctly in all browsers
import 'core-js/fn/map';
import 'core-js/fn/set';
import 'core-js/fn/promise';
import 'core-js/fn/string/includes';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/values';
import 'core-js/fn/object/entries';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/includes';

// packages
import React from 'react';
import ReactDOM from 'react-dom';

// styles
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/index.css';

// components
import App from './components/App';

ReactDOM.render(<App />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default;
    ReactDOM.render(<NextApp />, document.getElementById('root'));
  });
}



// WEBPACK FOOTER //
// ./src/index.js